export default {
  Requests_in_process: 'Solicitudes en proceso',
  Completed_requests: 'Solicitudes completadas',
  Uploaded_documents: 'Documentos subidos',
  Rejected_applications: ' Solicitudes rechazadas',
  My_profile: ' Mi Perfil',
  My_requests: 'Mis Solicitudes',
  Documents: 'Documentos',
  Personal_documents: 'Documentos Personales',
  Institutional_Documents: 'Documentos Institucionales',
  My_desk: 'Mi escritorio',
  Representative_Profile: 'Perfil del Representante',
  Edit_profile: ' Editar Perfil',
  Add_company_Name: ' Agregar empresa',
  Nombre: 'Nombre',
  Identification_document: 'Documento de Identidad',
  Business: 'Empresa',
  Telephone_contact: ' Telefono de contacto',
  Email: ' Correo Electrónico',
  Edit_Company: '	 Editar Empresa',
  Telephone: 'Teléfono',
  Town: 'Ciudad',
  Tradename: 'Nombre Comercial',
  address: 'Dirección',
  Modify_company: 'Modificar empresa',
  CONFIRMAR: '  CONFIRM',
  See_all: '   Ver todas',
  Requests_in_process: "Solicitudes en proceso",
  Completed_requests: 'Solicitudes completadas',
  // RequestCard
  COMPLETED: 'COMPLETADO',
  REJECTED: 'RECHAZADO',
  msgrequestRequires: '  Esta solicitud requiere de tu acción para continuar.',
  TO_COMPLETE: 'COMPLETAR',
  SEE_DETAIL: 'VER DETALLE',
  Date: 'Fecha',
  Business: 'Empresa',
  application_number: ' Solicitud No',
  status: 'Estado',

  MockupInProcessRequests: [
    {
      id: 1,
      percent: '60%',
      title: 'Solicitud de no objeción de suelo',
      status: 'actionRequired',
      serviceID: 1
    },
    {
      id: 2,
      percent: '90%',
      title: 'Solicitud de prueba ABC',
      status: 'inProcess',
      serviceID: 2
    },
  ],

  MockupCompletedRequests: [
    {
      id: 1,
      title: 'Clasificación Provisional',
      status: 'success',
      serviceID: 3
    },
    {
      id: 2,
      title: 'Guías Turísticos',
      status: 'success',
      serviceID: 4
    },
  ],

  MockupRejectedRequests: [
    {
      id: 1,
      title: 'Solicitud de ejemplo',
      status: 'rejected',
      serviceID: 5
    },
  ],

  //SERvICES REQUESTED DETAILS

  Details: 'Detalles',
  ComplaintsAndclaims: '  Quejas y Reclamaciones',
  Payments: 'Pagos',
  Required_action: '  Accion Requerida',

  //Actions required
  TextInformation: 'Información requerida',
  ActionTitle: 'Informacion',
  DocumentRequired: ' Documento requerido',
  document: 'Documento',

  //Detail
  RequestDetails: 'Detalles de Solicitud',
  CostOfService: 'Costo del servicio',
  Project: 'Proyecto',
  Investment_Amount: ' Monto de Inversión',
  Requested_by: 'Solicitado por',
  UploadedDocuments: 'Documentos subidos',

  //Document Request card
  DocumentName: ' Nombre del Documento',
  DocumentType: '  Tipo de Documento',
  See: 'Ver',

  //Complaints And Claims
  claim_created: 'Reclamación Creada',
  New_claim: 'Nueva Reclamación',
  reasonComplaint: 'Seleccione el motivo de la queja',
  Observations: 'Observaciones',
  AttachScreenshot: 'Adjuntar archivo o captura de pantalla',
  SEND: 'ENVIAR',
  Claims: 'Reclamaciones',
  Claim: 'Reclamacion',
  Complaint: 'Queja',
  Payment_date: 'Fecha de pago',
  NoCLaimAplication: 'No hay reclamaciones en esta solicitud',
  NEW_CLAIM: 'NUEVA RECLAMACIÓN',
  claimnumber: 'Numero de reclamacion ',
  contactwith_us: 'Gracias por ponerse en contacto con nosotros',

  //Payments
  Pay_service_tax: 'Pagar impuesto de servicio',
  Pay: 'Pago',
  MyPayments: 'Mis pagos',
  PaymentID: 'ID de pago',
  Amount_Paid: 'Monto Pagado',
  PaymentDate: 'Fecha de pago',

}